import { db } from "../firebase";
import { doc, setDoc, collection } from "firebase/firestore";

export default function useCreateDoc({ coll }) {
    const create = (data) => {
        const newDocRef = doc(collection(db, coll));
        return setDoc(newDocRef, { ...data, id: newDocRef.id }).then(() => newDocRef.id)
    }
    return { create }
}